// this is an autogenerated file from DesignSystem/CheckInAction/check-in-mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_CheckInAction($id: uuid!, $skip_connection_check: Boolean) {
  vaxiom_appointment_booking_check_in(
    id: $id
    skip_connection_check: $skip_connection_check
  ) {
    id
    appointment_booking {
      id
      _id
      state
      start_time
      end_time
      local_start_date
      local_start_time
      provider_id
      assistant_id
      chair_id
    }
  }
}

`